import { Repository, RepositoryBase } from '@/repository/base';

/**
 * マイページ情報のリポジトリアクセス
 */
export default class MyPageRepository extends RepositoryBase {
  private repository = '/mypage';

  /**
   * マイページ情報の取得
   */
  getMyPageInfo() {
    const config = {
      headers: {
        'x-exam-key': process.env.VUE_APP_EXAM_SECRET_KEY,
      },
    };
    return Repository.get(`${this.repository}`, config);
  }
}
